import { Params, ParamMap } from '@angular/router';

export const SERVICE_TYPE_KEY = 'service-type';

export const toServiceTypeParams = (args: { serviceTypeId?: number }): Params =>
	args.serviceTypeId || args.serviceTypeId === 0
		? {
				[SERVICE_TYPE_KEY]:
					args.serviceTypeId || args.serviceTypeId === 0
						? args.serviceTypeId
						: undefined,
		  }
		: undefined;

export const toServiceTypeListArgs = (
	paramMap: ParamMap
): { serviceTypeId?: number } =>
	paramMap.has(SERVICE_TYPE_KEY)
		? {
				serviceTypeId: +paramMap.get(SERVICE_TYPE_KEY),
		  }
		: undefined;
